"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BROWSER_NAME_MAPPING = {
    Edge: 'Microsoft Legacy Edge',
    Edg: 'Microsoft Edge',
    Chrome: 'Chrome',
    CriOS: 'Chrome',
    Firefox: 'Firefox',
    FriOS: 'Firefox',
    Safari: 'Safari',
};
const OPERATING_SYSTEM_NAMES = [
    {
        readableName: 'Windows NT 4.0',
        userAgentRegEx: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/,
    },
    { readableName: 'Windows 10', userAgentRegEx: /(Windows 10.0|Windows NT 10.0)/ },
    { readableName: 'Windows 8.1', userAgentRegEx: /(Windows 8.1|Windows NT 6.3)/ },
    { readableName: 'Windows 8', userAgentRegEx: /(Windows 8|Windows NT 6.2)/ },
    { readableName: 'Windows 7', userAgentRegEx: /(Windows 7|Windows NT 6.1)/ },
    { readableName: 'Windows Vista', userAgentRegEx: /Windows NT 6.0/ },
    { readableName: 'Windows Server 2003', userAgentRegEx: /Windows NT 5.2/ },
    { readableName: 'Windows XP', userAgentRegEx: /(Windows NT 5.1|Windows XP)/ },
    { readableName: 'Windows 2000', userAgentRegEx: /(Windows NT 5.0|Windows 2000)/ },
    { readableName: 'Windows ME', userAgentRegEx: /(Win 9x 4.90|Windows ME)/ },
    { readableName: 'Windows 98', userAgentRegEx: /(Windows 98|Win98)/ },
    { readableName: 'Windows 95', userAgentRegEx: /(Windows 95|Win95|Windows_95)/ },
    { readableName: 'Windows CE', userAgentRegEx: /Windows CE/ },
    { readableName: 'Windows 3.11', userAgentRegEx: /Win16/ },
    { readableName: 'Android', userAgentRegEx: /Android/ },
    { readableName: 'Chrome OS', userAgentRegEx: /CrOS/ },
    { readableName: 'Linux', userAgentRegEx: /(Linux|X11(?!.*CrOS))/ },
    { readableName: 'Mac OS', userAgentRegEx: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
    { readableName: 'Mac OS X', userAgentRegEx: /Mac OS X/ },
    { readableName: 'UNIX', userAgentRegEx: /UNIX/ },
    { readableName: 'iOS', userAgentRegEx: /(iPhone|iPad|iPod)/ },
];
const parseNavigatorString = (userAgent) => {
    let browser = 'Other Browser';
    let version = '-';
    let device = '';
    let versionOffset = -1;
    let operatingSystem = '-';
    let operatingSystemVersion = '';
    const setBrowserVersion = (versionOffset, userAgentBrowserName) => {
        let initialVersion = '';
        if (browser === 'Safari') {
            versionOffset = userAgent.indexOf('Version');
            initialVersion = userAgent.substring(versionOffset + 8);
        }
        else {
            initialVersion = userAgent.substring(versionOffset + userAgentBrowserName.length + 1);
        }
        const versionEndIndex = initialVersion.indexOf(' ');
        if (versionEndIndex !== -1) {
            version = initialVersion.substring(0, versionEndIndex);
        }
        else {
            // the relevant version is already at the end of the userAgent string
            version = initialVersion;
        }
    };
    const setBrowserInfo = (userAgentBrowserName, readableBrowserName) => {
        versionOffset = userAgent.indexOf(userAgentBrowserName);
        // only set the browser if it has not already been set since mobile lists safari at the end
        if (versionOffset !== -1 && browser === 'Other Browser') {
            browser = readableBrowserName;
            setBrowserVersion(versionOffset, userAgentBrowserName);
        }
    };
    const setOperatingSystemAndDeviceInfo = (readableName) => {
        if (/Windows/.test(readableName)) {
            const parsedReadableName = /Windows (.*)/.exec(readableName);
            operatingSystemVersion = String(parsedReadableName && parsedReadableName?.length > 1 ? parsedReadableName[1] : '');
            operatingSystem = 'Windows';
            device = 'Windows';
        }
        switch (readableName) {
            case 'Mac OS':
            case 'Mac OS X':
                // iPads on iOS 13 are nearly indistinguishable from macs
                if (navigator.maxTouchPoints > 1) {
                    device = 'iPad';
                    operatingSystem = 'iOS';
                }
                else {
                    device = 'Mac';
                }
            // intentional fall through to grab the correct operatingSystemVersion for Mac OS, Mac OS X, or Android
            case 'Android':
                const parsedUserAgent = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(userAgent);
                operatingSystemVersion = String(parsedUserAgent && parsedUserAgent?.length > 1 ? parsedUserAgent[1] : '');
                if (readableName === 'Android') {
                    device = 'Android';
                }
                operatingSystem = readableName;
                break;
            case 'iOS':
                operatingSystemVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(userAgent);
                operatingSystemVersion = operatingSystemVersion
                    ? operatingSystemVersion[1] +
                        '.' +
                        operatingSystemVersion[2] +
                        '.' +
                        (operatingSystemVersion[3] || 0)
                    : '-';
                if (/iPhone/.test(userAgent)) {
                    device = 'iPhone';
                }
                else if (/iPad/.test(userAgent)) {
                    device = 'iPad';
                }
                else if (/iPod/.test(userAgent)) {
                    device = 'iPod';
                }
                operatingSystem = readableName;
                break;
        }
    };
    Object.entries(BROWSER_NAME_MAPPING).forEach(([userAgentBrowserName, readableBrowserName]) => {
        setBrowserInfo(userAgentBrowserName, readableBrowserName);
    });
    OPERATING_SYSTEM_NAMES.forEach(({ readableName, userAgentRegEx }) => {
        if (userAgentRegEx.test(userAgent)) {
            setOperatingSystemAndDeviceInfo(readableName);
        }
    });
    const results = {
        operatingSystem: operatingSystem,
        operatingSystemVersion: operatingSystemVersion,
        browserVersion: browser + ' ' + version,
        device,
    };
    return results;
};
exports.default = parseNavigatorString;
